export default __webpack_public_path__ + "static/successRocket-02c2706b34f65aa3697eb3580982f09d.svg";